import { DeliveryDeviation, Dimension, Tracking } from '../../../models';
import { SCode } from '../../../../common';

export enum ItemTrackingContentType {
  DN = 'DN',
  HU = 'HU',
}

export enum ShippingIcon {
  Air = 'AIR',
  AirExpress = 'AIR_EXPRESS',
  Store = 'STORE',
  Truck = 'TRUCK',
}

export enum ItemTrackingContentTypeFromSAP {
  DN = 'deliveryNote',
  HU = 'handlingUnit',
}

export interface PublicTrackingHandlingUnit {
  id: string;
  barcodeId: string;
  lastStatusCode: SCode;
  lastStatusDescription: string;
  timestamp?: null;
  statusChain: Tracking[];
}

export interface DefaultDeliveryNoteModel {
  carrierName: string;
  deliveryDeviation: DeliveryDeviation;
  deliveryNoteNumber: string;
  destinationAddress: string;
  estimatedArrivalTime?: number;
  externalDeliveryNoteNumber?: string;
  origin: string;
  reason: string;
  shippingCondition?: string;
  shippingIcon?: ShippingIcon;
  statusChain: Tracking[];
  volume: Dimension;
  weight: Dimension;
  trackingId: string;
}

export interface DeliveryNotePublicTrackingView extends DefaultDeliveryNoteModel {
  handlingUnits: PublicTrackingHandlingUnit[];
}

export interface PublicTrackingItemModel {
  deliveryNotePublicView: DeliveryNotePublicTrackingView;
  trackingContentType: ItemTrackingContentType;
  zipCodeRequired: boolean;
  sapId?: string;
}
